

export enum TransferState {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  DENIED = 'DENIED',
  CANCELLED = 'CANCELLED',
};
